import { FormikProps, FormikProvider } from 'formik';
import ConfirmDismissModal from './ConfirmDismissModal';
import PostMirrorCompletionModal from './PostMirrorCompletionModal';
import { PostMirrorCompletionRequest } from './types';
import usePostMirrorCompletion from './usePostMirrorCompletion';

type Props = {
    request: PostMirrorCompletionRequest;
    formik: FormikProps<any>;
    isDeclarationLoaded: boolean;
    saveDeclaration: () => Promise<any>;
    onDone: () => void;
};

/**
 * Everything the post-mirror completion prompt needs, mounted only for a declaration that has just
 * been generated by mirroring.
 *
 * The fields are rendered against the master form's own formik, so they are the form's fields rather
 * than copies of them - what the user picks here is picked on the declaration.
 */
const PostMirrorCompletionPrompt = ({ request, formik, isDeclarationLoaded, saveDeclaration, onDone }: Props) => {
    const {
        isOpen,
        fields,
        isSaving,
        canSave,
        isConfirmingDismiss,
        requestDismiss,
        cancelDismiss,
        dismiss,
        saveAndContinue,
    } = usePostMirrorCompletion({
        formik,
        isDeclarationLoaded,
        saveDeclaration,
        onDone,
    });

    return (
        <FormikProvider value={formik}>
            <PostMirrorCompletionModal
                open={isOpen}
                fields={fields}
                sourceMessageType={request.sourceMessageType}
                isSaving={isSaving}
                canSave={canSave}
                onSave={saveAndContinue}
                onDismiss={dismiss}
                onClose={requestDismiss}
            />
            <ConfirmDismissModal
                open={isConfirmingDismiss}
                messageType={request.messageType}
                onConfirm={dismiss}
                onCancel={cancelDismiss}
            />
        </FormikProvider>
    );
};

export default PostMirrorCompletionPrompt;
